export default __webpack_public_path__ + "static/enterprise-57fdfccdf4726b67546983c89cd4a0fc.svg";